import { Injectable } from '@angular/core';
import { Firestore, collection, query, where, getDocs, doc, updateDoc, addDoc } from '@angular/fire/firestore';
import { Project } from '../interfaces/project';
import { UserService } from './user.service';

@Injectable({
  providedIn: 'root'
})
export class DraftService {
  
  constructor(
    private firestore: Firestore,
    private userService: UserService
  ) { }

  async getUserDrafts(): Promise<Project[]> {
    const uid = this.userService.getUID();
    if (!uid) return [];

    const projectsRef = collection(this.firestore, 'projects');
    const q = query(
      projectsRef, 
      where('owner', '==', uid),
      where('status', '==', 'draft')
    );
    
    const querySnapshot = await getDocs(q);
    const drafts: Project[] = [];
    
    querySnapshot.forEach((doc) => {
      drafts.push({ id: doc.id, ...doc.data() } as Project);
    });
    
    return drafts;
  }

  async saveDraft(project: Project): Promise<string> {
    const uid = this.userService.getUID();
    if (!uid) throw new Error('User not authenticated');

    project.owner = uid;
    project.status = 'draft';
    project.dateEdited = new Date().toISOString();
    project.Saved = true; // Mark as saved when successfully stored in Firebase

    const projectsRef = collection(this.firestore, 'projects');
    
    if (project.id) {
      // Update existing draft
      const docRef = doc(this.firestore, 'projects', project.id);
      const { id, ...projectData } = project;
      await updateDoc(docRef, projectData);
      return project.id;
    } else {
      // Create new draft
      const docRef = await addDoc(projectsRef, project);
      return docRef.id;
    }
  }

  async deleteDraft(draftId: string): Promise<void> {
    const docRef = doc(this.firestore, 'projects', draftId);
    // Note: You might want to actually delete the document or mark it as deleted
    await updateDoc(docRef, { status: 'deleted' });
  }
}